import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn, Note, SideCancelBtn } from "../Styles/InputStyles";
import Model from "../Model";
import { toast } from "react-toastify";
import { MdOutlineInfo } from "react-icons/md";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { FaSpinner, FaToggleOff, FaToggleOn } from "react-icons/fa";

const EditDuesModel = ({
  editDuesMutate,
  editDueLoading,
  setIsEditDues,
  selectedData,
  hideDueLoading,
  hideDueMutate,
  canHideDues,
  e
}) => {

  const SubmitHandler = (values) => {
    if (!values.balance) {
      toast.error("Please enter due balance");
      return;
    }
    editDuesMutate(values);
  };
  const handleToggleHideDue = () => {
    const newHideValue = formik.values.hideFromTenant === 0 ? 1 : 0;

    hideDueMutate({
      dueId: formik.values.id,
      toggleValue: newHideValue,
      e: e
    });
    formik.setFieldValue("hideFromTenant", newHideValue);
  };

  const formik = useFormik({
    initialValues: {
      id: selectedData?.id || "",
      balance: selectedData?.balance || "",
      type: selectedData?.type || "",
      tenantId: selectedData?.tenantId || "",
      ledgerReferenceId: selectedData?.ledgerReferenceId || "",
      clientId: selectedData?.clientId || "",
      hideFromTenant: selectedData?.hideFromTenant || 0,

    },

    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-md`} setOpenModel={setIsEditDues} title={"Edit Dues"}>
      {/* {editDueLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : ( */}
      <Wrapper>
        {/* <Title>Edit Dues</Title> */}
        <form onSubmit={formik.handleSubmit}>
          <Wrapper>
            <InputGroup>
              <Label htmlFor="balance">Balance (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  name="balance"
                  id="balance"
                  autoComplete="off"
                  className="truncate"
                  required
                  value={formik.values.balance}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    if (value.length <= 7) {
                      // Limits the length to 7 digits
                      formik.setFieldValue("balance", value);
                    }
                  }}
                />
                <Note className="mt-1">
                  <MdOutlineInfo className="mt-0.5 mr-1" />
                  To delete the due, set its value to zero.
                </Note>
              </FieldWrapper>
            </InputGroup>
            {canHideDues === 1 &&
              <InputGroup>
                <div className="flex items-center justify-between">
                  <Label>
                    Hide due from tenant
                  </Label>
                  <ToggleSwitchWrapper>
                    {hideDueLoading ? (
                      <div className="flex items-center justify-center h-6 w-11">
                        <FaSpinner className="animate-spin text-gray-400" size={16} />
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={handleToggleHideDue}
                        disabled={editDueLoading || hideDueLoading}
                        className={`
            relative inline-flex h-6 w-11 items-center rounded-full
            transition-colors duration-200 focus:outline-none
            ${formik.values.hideFromTenant === 1 ? 'bg-primary-color' : 'bg-gray-600'}
          `}
                      >
                        <span
                          className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200
              ${formik.values.hideFromTenant === 1 ? 'translate-x-6' : 'translate-x-1'}
            `}
                        />
                      </button>
                    )}
                  </ToggleSwitchWrapper>
                </div>
              </InputGroup>}
          </Wrapper>
          <BtnWrapper>
            <SideCancelBtn
              type="button"
              onClick={() => setIsEditDues(false)}
            >
              Cancel
            </SideCancelBtn>
            <SubmitBtn type="submit"
              disabled={editDueLoading || hideDueLoading}
            >
              {editDueLoading ? "Updating" : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </Wrapper>
      {/* )} */}
    </Model>
  );
};

const Wrapper = tw.div`space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

const ToggleSwitchWrapper = tw.div`relative`;

export default EditDuesModel;
